import React, {useCallback} from 'react';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';

const LinkWrapper = styled.div`
  color: ${(props) => props.theme.normalTextColor};
  cursor: pointer;
  :hover {
    color: ${(props) => props.theme.primaryColor};
  }
`;

export default function Link({text, path, customStyle}) {
  const history = useHistory();

  const onLinkPress = useCallback(() => {
    history.push(path);
  }, [history, path]);

  return (
    <LinkWrapper style={customStyle} onClick={onLinkPress}>
      {text}
    </LinkWrapper>
  );
}
